export default __webpack_public_path__ + "static/media/02.09f5f949.jpg";